import AuthenticatedScrumbleApiClient from '@/repositories/clients/AuthenticatedScrumbleApiClient';

export default {
  balance() {
    return AuthenticatedScrumbleApiClient.get('me/tokens/balance');
  },

  topUpOptions() {
    return AuthenticatedScrumbleApiClient.get('user/tokens/top-up-options');
  },

  topUpCheckout(packKey) {
    return AuthenticatedScrumbleApiClient.get('user/tokens/top-up-checkout', {
      params: packKey ? { pack: packKey } : undefined,
    });
  },

  updateAutoRecharge(payload) {
    return AuthenticatedScrumbleApiClient.put('user/tokens/auto-recharge', payload);
  },

  billingPortal() {
    return AuthenticatedScrumbleApiClient.get('stripe/billing-portal');
  },
};
